// @flow

// Libs
import createReducer from 'fc-utils/createReducer'

// Initial State
import initialState from './initialState'

// Controller
import controller from 'fc-ctrl-seasons'

// Export
export default createReducer(initialState, controller.reducers)
